/*
 * iurop-social — carrusel "Nuestras redes". Flechas prev/next que desplazan el
 * track de corazones (scroll-snap). Sin dependencias.
 */
(function () {
  function init(root) {
    if (root.dataset.ksInit) return;
    root.dataset.ksInit = '1';
    var track = root.querySelector('[data-ks-soc-track]');
    var prev = root.querySelector('[data-ks-soc-prev]');
    var next = root.querySelector('[data-ks-soc-next]');
    if (!track) return;
    // Carrusel en BUCLE INFINITO con peek (Figma): 3 corazones enteros al centro
    // + medio asomando a cada lado. Clonamos COPIES juegos completos del set real
    // a ambos lados, así siempre hay corazones para asomar y se puede girar sin
    // tope. Las flechas avanzan 1 corazón; antes de animar se recoloca pos a la
    // banda central por ±n — salto INVISIBLE porque los juegos son idénticos —,
    // de modo que nunca se agota el buffer por mucho que se pulse.
    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (n < 1) return;
    var COPIES = 2;
    var i, c, clone, links, j;
    function addClone(node, atStart) {
      clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      links = clone.querySelectorAll('a');
      for (j = 0; j < links.length; j++) links[j].tabIndex = -1;
      if (atStart) track.insertBefore(clone, track.firstChild);
      else track.appendChild(clone);
    }
    for (c = 0; c < COPIES; c++) { for (i = n - 1; i >= 0; i--) addClone(originals[i], true); }
    for (c = 0; c < COPIES; c++) { for (i = 0; i < n; i++) addClone(originals[i], false); }
    var total = track.children.length;
    var lo = n, hi = total - n;
    var pos = COPIES * n + Math.floor(n / 2); // corazón del medio del juego real

    function place(anim) {
      var it = track.children[0];
      var w = it.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      // Diseno del cliente: TRES corazones enteros y MEDIO a cada lado. El ancho
      // de tarjeta es una fraccion exacta del carrusel (ver iurop-social.scss),
      // asi que basta desplazar medio corazon para que el reparto salga
      // medio + 3 enteros + medio a CUALQUIER ancho de pantalla.
      var x = -(pos * (w + gap)) + w / 2;
      track.style.transition = anim ? 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }
    function go(d) {
      while (pos < lo) pos += n;   // reposición INVISIBLE (juegos idénticos)
      while (pos >= hi) pos -= n;
      place(false);
      void track.offsetWidth;      // fuerza reflow: confirma el reset antes de animar
      pos += d;
      place(true);
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', function () { place(false); });

    // ---------------------------------------------------------------------
    // Arrastre por puntero (móvil: sin flechas → se desliza con el dedo).
    // El track se mueve por transform (no scroll nativo), así que NO crea un
    // contenedor de scroll y NO atrapa el scroll vertical de la página; con
    // touch-action:pan-y el navegador conserva el gesto vertical y a nosotros
    // nos llega solo el horizontal. Al soltar, snap al corazón más cercano
    // reutilizando la lógica de bucle (pos + banda central).
    // ---------------------------------------------------------------------
    var dragging = false, decided = false, horiz = false, startX = 0, startY = 0, baseX = 0, pid = null;
    function curX() {
      var m = /translateX\(\s*(-?[0-9.]+)px/.exec(track.style.transform || '');
      return m ? parseFloat(m[1]) : 0;
    }
    function stepWidth() {
      var it = track.children[0];
      var w = it.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return w + gap;
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; decided = false; horiz = false; pid = e.pointerId;
      startX = e.clientX; startY = e.clientY; baseX = curX();
      track.style.transition = 'none';
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        decided = true; horiz = Math.abs(dx) > Math.abs(dy);
        if (horiz) { try { track.setPointerCapture(pid); } catch (_) {} }
      }
      if (!horiz) return;            // gesto vertical → scroll de página (navegador)
      e.preventDefault();
      track.style.transform = 'translateX(' + (baseX + dx) + 'px)';
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { track.releasePointerCapture(pid); } catch (_) {}
      if (!horiz) return;
      var dx = (e.clientX || startX) - startX;
      var d = Math.round(-dx / stepWidth());
      if (d !== 0) pos += d;
      place(true);                   // anima al corazón snapeado
      // Tras animar, renormaliza a la banda central (salto invisible: juegos idénticos).
      setTimeout(function () {
        var changed = false;
        while (pos < lo) { pos += n; changed = true; }
        while (pos >= hi) { pos -= n; changed = true; }
        if (changed) place(false);
      }, 480);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    place(false);
  }
  function boot() { document.querySelectorAll('[data-ks-soc-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-ks-soc-carousel]');
    if (c) init(c);
  });
})();
